import React from 'react'
import type { FC } from 'react'
import { Clock } from 'lucide-react'
import { format, setDefaultOptions } from 'date-fns'
import { tr } from 'date-fns/locale'
setDefaultOptions({ locale: tr })
import { Badge } from './badge'

import type { Post } from '@payload-types'
import { Separator } from '../ui/separator'

interface PostHeaderProps {
  post: Post
}

export const PostHeader: FC<PostHeaderProps> = ({ post }) => {
  return (
    <div>
      {/* Tags and metadata */}
      <div className="flex flex-row justify-between items-center my-4">
        <div className="flex flex-row gap-4">
          {/* Categories */}
          {post.categories && post.categories.length > 0 && (
            <div className="flex flex-row gap-2 flex-wrap">
              {post.categories.map((category, index) => {
                if (typeof category !== 'object' || !category.title || !category.slug) return null

                return (
                  <Badge
                    key={index}
                    title={category.title}
                    href={`/haberler/${category.slug}`}
                    variant="primary"
                  />
                )
              })}
            </div>
          )}
        </div>

        {post.publishedAt && (
          <div className="flex flex-col items-center gap-1 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <Clock className="h-4 w-4 text-primary" />
              <span className="text-xs text-foreground">
                {format(new Date(post.publishedAt), 'd MMMM yyyy, HH:mm')}
              </span>
            </div>
            {post.updatedAt && post.updatedAt !== post.publishedAt && (
              <span className="text-xs text-muted-foreground">
                (Güncellendi: {format(new Date(post.updatedAt), 'd MMMM yyyy, HH:mm')})
              </span>
            )}
          </div>
        )}
      </div>
      <Separator className="my-2" />
      <h1 className="text-2xl font-bold mb-3">{post.title}</h1>
      {post.spot && <div className="text-sm italic text-muted-foreground">{post.spot}</div>}
      <Separator className="my-2" />
    </div>
  )
}
